module.exports = __webpack_public_path__ + "static/napf-acd14023e07973dc83f094c8b3c8d969.png";